import axios from 'axios';
import { Core } from 'managers';
import { LOGOUT_SUCCESS, LOGOUT_ERROR } from 'constants/ActionTypes';
import { ADMIN_API_URL, BACKEND2_API_URL } from 'constants/Environment';

export default {
    setupInterceptors: (store) => {
        axios.interceptors.request.use(
            (config) => {
                const token = Core.cacheManager.getTokenStore();

                if (
                    token != null &&
                    (config.url.indexOf(ADMIN_API_URL) !== -1 ||
                        config.url.indexOf(BACKEND2_API_URL) !== -1)
                ) {
                    config.headers.Authorization = `Bearer ${token}`;
                }
                return config;
            },
            (err) => Promise.reject(err),
        );

        axios.interceptors.response.use(
            (response) => response,
            (error) => {
                if (error.response && error.response.status === 401) {
                    Core.authenticationManager.logout().then(
                        () =>
                            store.dispatch({
                                type: LOGOUT_SUCCESS,
                            }),
                        () =>
                            store.dispatch({
                                type: LOGOUT_ERROR,
                            }),
                    );
                }
                return Promise.reject(error);
            },
        );
    },
};
